import React from 'react'
import i18n from 'live/services/i18n'

type Props = {
    purgeExceptionRule: PurgeExceptionRule
    readonly: boolean
    setEditingRule: (purgeRule: PurgeRule) => void
    removePurgeExceptionRule: (purgeExceptionRule: PurgeExceptionRule) => void
}

const PurgeExceptionRule = ({
    purgeExceptionRule,
    readonly,
    setEditingRule,
    removePurgeExceptionRule
}: Props): JSX.Element => {
    return (
        <>
            <td></td>
            <td style={{ color: 'var(--green-700)' }}>
                <i className="fa fa-lock" />
                <span>{i18n('Keep')}</span>
            </td>
            <td>
                <span>{purgeExceptionRule.eventType}</span>
            </td>
            <td>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span></span>
                    {!readonly && (
                        <div>
                            <a
                                onClick={() => {
                                    setEditingRule({ ...purgeExceptionRule, timeRange: '', recurrent: false })
                                }}
                            >
                                <i className="fa fa-pencil" style={{ color: 'var(--blue-500)' }} />
                            </a>
                            <a onClick={() => removePurgeExceptionRule(purgeExceptionRule)}>
                                <i
                                    className="fa fa-times-circle-o"
                                    style={{
                                        marginLeft: '16px',
                                        color: 'var(--red-500)'
                                    }}
                                />
                            </a>
                        </div>
                    )}
                </div>
            </td>
        </>
    )
}

export default PurgeExceptionRule
